module.exports = __webpack_public_path__ + "img/icon_map_ljpgfm.3979ce71.png";